import React from "react";
import SubArabElectricians from "./subArabElectricians";
import { Link } from "react-router-dom";
import {FaArrowUp} from "react-icons/fa";

function subArab() {
  return (
    <div className="container">
      <div className="row EmpContentSec">
        <div className="col-12">
          <SubArabElectricians />
        </div>
      </div>
      <div className="row EmpContentSec">
        <div className="col-12">
          <SubArabElectricians />
        </div>
      </div>
      <div className="row EmpContentSec">
        <div className="col-12">
          <SubArabElectricians />
        </div>
      </div>
      <div className="row EmpContentSec">
        <div className="col-12">
          <SubArabElectricians />
        </div>
      </div>
      <div className="row EmpContentSec">
        <div className="col-12">
          <SubArabElectricians />
        </div>
      </div>
      <div className="row EmpContentSec">
        <div className="col-12 subQaExportBtn">
          <Link to="/export-sheet" className="UserManagementTDU">
            <span className="UserMgmtNewUsers">< FaArrowUp /> Export Sheet</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default subArab;
